export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8094.b0c317b0.jpg";